import VoteWidget from './VoteWidget'
import { consensusOfTheWeek } from '../data/articles'

export default function Consensus() {
  return (
    <section className="consensus">
      <div className="wrap sec" style={{ borderTop: 0 }}>
        <div className="cons-grid">
          <div className="cons-copy">
            <div className="kick label">Prepper Consensus</div>
            <h2>The Whole Community, On The Record</h2>
            <p>
              Every dispatch carries a live vote. Thousands of readers weigh in on how they actually store, build, and plan, so you can
              see the real distribution, not one expert's opinion.
            </p>
            <div className="cons-stats">
              <div className="st">
                <div className="v tnum">41K</div>
                <div className="k">Votes cast</div>
              </div>
              <div className="st">
                <div className="v tnum">120+</div>
                <div className="k">Live polls</div>
              </div>
              <div className="st">
                <div className="v tnum">
                  48<span style={{ fontSize: 18 }}>hr</span>
                </div>
                <div className="k">New question cadence</div>
              </div>
            </div>
          </div>

          <div className="cons-panel">
            <div className="cp-head">
              <span className="t">This Week's Question</span>
              <span className="live">
                <span className="live-dot" style={{ width: 6, height: 6 }} aria-hidden="true"></span> Live
              </span>
            </div>
            <VoteWidget poll={consensusOfTheWeek} compact />
          </div>
        </div>
      </div>
    </section>
  )
}
